'use client';

import { useQuery } from '@tanstack/react-query';

import { Services } from '@/infra/services';

const useGetProductsMap = (page: number) => {
  const result = useQuery({
    queryKey: ['get-products-map', page],
    queryFn: () => Services.SiteMap.getProductsMap({ page: page }),
  });

  return result;
};

export default useGetProductsMap;
